export interface PaysafeBillingAddress {
  city?: string;
  country: string;
  state?: string;
  street?: string;
  street2?: string;
  zip: string;
  useAsShippingAddress?: boolean;
}
